import { useToggle } from '@deltasierra/react-hooks';
import * as React from 'react';
import { t } from '@deltasierra/shared';
import Close from '@material-ui/icons/Close';
import { DSConfirmDialog } from '../mui';
import { DSIconButton } from '../Generic/Buttons/DSIconButton';

export interface MultiItemPickerCloseButtonProps {
    className?: string;
    onClose?: () => void;
}

export function MultiItemPickerCloseButton({ className, onClose }: MultiItemPickerCloseButtonProps): JSX.Element {
    const [isOpen, toggle] = useToggle();

    const handleClose = () => {
        toggle('toggleOff');
        onClose?.();
    };

    return (
        <>
            <DSIconButton
                aria-label={t('COMMON.CLOSE')}
                className={className}
                color="error"
                data-cy="delete-multi-item-button"
                data-testid="delete-multi-item-button"
                size="small"
                onClick={() => toggle('toggleOn')}
            >
                <Close />
            </DSIconButton>
            <DSConfirmDialog
                confirmColor="error"
                confirmText={t('COMMON.REMOVE')}
                dialogTitle={t('BUILD.MULTI_IMAGE.REMOVE_IMAGE.TITLE')}
                message={t('BUILD.MULTI_IMAGE.REMOVE_IMAGE.MESSAGE')}
                open={isOpen}
                onCancel={() => toggle('toggleOff')}
                onConfirm={handleClose}
            />
        </>
    );
}
MultiItemPickerCloseButton.displayName = 'MultiItemPickerCloseButton';
